import { AppState, WidgetPageDublinAppState } from '../../../initialStateRegistration';

const getWidgetPage = (state: AppState) => (state as WidgetPageDublinAppState).template;

export const getMetadataDescription = (state: AppState) => getWidgetPage(state).metadataDescription;

export const getMetadataTitle = (state: AppState) => getWidgetPage(state).metadataTitle;

export const getMetadataImage = (state: AppState) => getWidgetPage(state).metadataImage;

export const getSportradarProps = (state: AppState) => getWidgetPage(state).sportradarProps;
